/**
 * 在所有会话中按关键字查找
 */
import { useMemo, useState } from "react";
import { useAllSession } from "./useAllSession";
import { useAtomValue } from "jotai";
import { SessionListAtom } from "../store";
import { ChatConfereesItem, ChatMessageItem, SessionListItem } from "../types";
import _ from "underscore";
import { getFullMessageText } from "./common";

export default function useFilterSessionList() {
    const { sessions } = useAllSession();
    const originalList = useAtomValue(SessionListAtom);

    const [searchText, setSearchText] = useState("");

    const sessionList = useMemo(() => {
        if (!searchText) return originalList;

        const filteredSessionIds = sessions
            .filter(isSessionContainText)
            .map(item => item.guid);

        return originalList.filter(item =>
            filteredSessionIds.includes(item.guid)
        );
    }, [originalList, searchText]);

    // 会话中是否符合查询条件
    function isSessionContainText(session: SessionListItem) {
        if (session.sessionTopic.includes(searchText)) return true;
        if (_.any(session.chatConferees, isContactContainText)) return true;
        if (_.any(session.chatMessages, isMessageContainText)) return true;

        if (session.chatConferees) return false;
    }

    function isMessageContainText(message: ChatMessageItem) {
        const content = getFullMessageText(message);
        return content.includes(searchText);
    }

    function isContactContainText(contact: ChatConfereesItem) {
        if (contact.name.includes(searchText)) return true;
        return contact.no.includes(searchText);
    }

    return { searchText, setSearchText, sessionList };
}
